// extracted by mini-css-extract-plugin
module.exports =  {"select":"pZmsChWTUhUajn3CTZlU"};